import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AppService} from "@irb/app.service";
import {IrbClientsService} from "@irb/irb-clients/irb-clients.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {IrbAppEvents} from "@irb/app.events";

@Component({ standalone: false,
  selector: 'irb-import-loss-priority-settings-errors-dialog',
  templateUrl: './import-loss-priority-settings-errors-dialog.component.html',
  styleUrls: ['./import-loss-priority-settings-errors-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportLossPrioritySettingsErrorsDialogComponent implements OnInit {
  lossPriorityValues: any = {
    ST: 'Use Short Term losses only to meet the target',
    ST_ONLY: 'Use Short Term losses only to meet the target',
    LT: 'Use Long Term losses only to meet the target',
    LT_ONLY: 'Use Long Term losses only to meet the target',
    STLT: 'Use Short, then long term losses to meet the target',
    ST_LT: 'Use Short, then long term losses to meet the target',
    LARGESTLOSS: 'Use all losses, prioritizing from the largest $ loss first to minimize trades',
    LARGEST_LOSS: 'Use all losses, prioritizing from the largest $ loss first to minimize trades',
  };
  lossPriorityDialogData: any;
  constructor(
      public dialogRef: MatDialogRef<ImportLossPrioritySettingsErrorsDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public mdd: any,
      public as: AppService,
      public cs: IrbClientsService,
      private ies: IrbEditorsService,
  ) { }

  ngOnInit(): void {
    this.lossPriorityDialogData = this.mdd;
  }
  close() {
    this.dialogRef.close();
  }
  continue() {
    //directly call the valid records call. with valid records here.
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    
    this.ies.importValidLossTargetSettings(this.lossPriorityDialogData.validRecords,this.lossPriorityDialogData.analysisId).subscribe((responseObj: any) => {
      let totalImportCount = 0;
      const validLossTargetResponse = JSON.parse(responseObj);
        
      if (validLossTargetResponse && validLossTargetResponse.responseStatus != "EXCEPTION" && validLossTargetResponse.responseData !== undefined
            && validLossTargetResponse.responseData.analysisPortDtoList !== undefined) {

          validLossTargetResponse.responseData.analysisPortDtoList.map((portfolio: any) => {          
            portfolio.lossPrty = (portfolio.lossPrty === "" ? this.mapLossPriority("LARGESTLOSS") : this.mapLossPriority(portfolio.lossPrty));
          });
          
          let totalImported = validLossTargetResponse.responseData.analysisPortDtoList.filter((x:any)=>x.isImported);

          if(totalImported && totalImported.length > 0) {
            totalImportCount = totalImported.length;
          }
          
          this.as.fireEvent(IrbEditorsEvents.REFRESH_LOSS_PRIORITY_GRID, validLossTargetResponse);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: totalImportCount + ' portfolios had Loss Target settings imported.'
          });
        } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            summary: 'Import Loss Priority Settings',
            detail: 'No portfolios had Loss Target settings imported.'
          });
        }
      }, () => {
      }, () => {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.close();
      });

  }
  mapLossPriority(lossPrty: string) {
    if (lossPrty) {
      let key = lossPrty.toUpperCase();
      return this.lossPriorityValues[key];
    } else {
      return lossPrty;
    }
  }
}
